export default __webpack_public_path__ + "static/blob1-ac52ca43b2b6bb0e354cee12772e897e.svg";